export const API_URL = 'https://openaccess-api.clevelandart.org/api/artworks/'
export const TIMEOUT_PERIOD = 10;
export const RESULST_PER_PAGE = 10;
export const MAX_RESULT_LIMIT = 50;